module.exports = __webpack_public_path__ + "img/2.d948b965.png";